import { useResource } from '@lp/features/RoutePlanner/hooks/useResource';
import { RouteResourceCard } from './RouteResourceCard';
import { CaseFacility, CaseResourceType } from '@/api/apis/case';

type SurgeonCardProps = {
  id?: string;
  donorHospital?: CaseFacility;
  disabled?: boolean;
};

export const SurgeonCard = ({ id = '', donorHospital, disabled }: SurgeonCardProps) => {
  const { resource, resourceData, handleAssignModal, handleViewResourceModal } = useResource({
    type: CaseResourceType.Surgeon,
    id,
    donorHospital,
  });

  return (
    <div className="w-48 shrink-0">
      <RouteResourceCard
        type="retrieval-surgeon"
        hasResource={!!resource}
        imageUrl={resourceData.imageUrl}
        title={resourceData.title}
        statusType={resourceData.statusType}
        subTitle={resourceData.subTitle}
        status={resource?.logisticsStatus}
        statusText={resourceData.statusText}
        showAssignButton={resourceData.showAssignButton}
        onOpen={handleAssignModal}
        onClick={disabled ? () => null : handleViewResourceModal}
      />
    </div>
  );
};
